<div class="w-full h-full p-4 md:p-12 overflow-y-scroll hide-bar">
@if(dataParams.customActionsTop && dataParams.customActionsTop.length > 0){<div
    class="flex flex-wrap gap-4 place-content-end mb-4">
    @for (customAction of dataParams.customActionsTop; track $index) {
    <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary"
        (click)="generateCustomAction(customAction.component,null)">{{customAction.translateLabel ?
        t(customAction.label) : customAction.label}}</std-button>
    }
</div>}
   @if(!dataParams.customCard){ <std-card cardClass="h-auto mb-6" headerClass="bg-primary">
    <div header class="text-tertiary text-title">{{t('detail')}}</div>
    <div content class="flex items-center flex-wrap gap-[6%] lg:gap-[2%] lower-medium">
      @for (detail of dataParams.details; track detail) {
        <div class="w-[47%] lg:w-[32%] mb-6"
          [ngClass]="{'opacity-50 pointer-events-none': !detail.editable}">
          @if(detail.type !== 'select' && detail.type !== 'image'){ <std-input customInputClass="custom-input"
            customLabel="label-input" [type]="detail.type" [(ngModel)]="myData[detail.element]"
            [label]="t('labels.'+detail.element)  + (detail.obligatory ? '*' : '') " labelPosition="top"
          [placeholder]="t('placeholders.'+detail.element)  + (detail.obligatory ? '*' : '') "> </std-input>}
          @if(detail.type == 'image'){
            <div class="flex items-center gap-4">
              @if(myData[(detail.tableElementToVisualize && detail.tableElementToVisualize.length > 0) ? detail.element + 'ToVisualize' : detail.element]){
                <img [src]="baseUrl + '/'+ myData[(detail.tableElementToVisualize && detail.tableElementToVisualize.length > 0) ? detail.element + 'ToVisualize' : detail.element]">
              }
              <input class="h-fit" [ngClass]="{'hidden': myData[(detail.tableElementToVisualize && detail.tableElementToVisualize.length > 0) ? detail.element + 'ToVisualize' : detail.element]}"
              [id]=" 'file-'+detail.element" type="file" (change)="manageFiles($event,detail)"
              [placeholder]="t('placeholders.'+detail.element)">
            </div>
          }
        </div>
      }
      <div class="md:flex gap-4 place-content-center w-full">
        <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary w-full md:min-w-[200px]"
        (click)="createElement(t)">{{t('save')}}</std-button>
      </div>

      @if(dataParams.customActionsCard && dataParams.customActionsCard.length > 0){<div
        class="flex flex-wrap gap-4 place-content-center mt-4 mx-auto">
        @for (customAction of dataParams.customActionsCard; track $index) {
          <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary"
            (click)="generateCustomAction(customAction.component,null)">{{customAction.translateLabel ?
          t(customAction.label) : customAction.label}}</std-button>
        }
      </div>}

    </div>
  </std-card>}

        <div [ngClass]="{'hidden': !dataParams.customCard}" #customCardUniversalDetailsContainer id="custom-card-universal-details-container"></div>

    <div #customTabsUniversalDetailsContainer id="custom-tabs-universal-details-container" [ngClass]="{'hidden': !dataParams.customTabs}"></div>
    <std-modal  cardClass="!max-w-[90vw]" headerClass="bg-primary" [show]="showModelDelete" [closeOnOutside]="false"
        (close)="showModelDelete=false">
        <div class="text-tertiary text-large" header>{{t('modal.delete')}}</div>
        <div content>
            <div class="text-primary text-medium">{{t('modal.confirmation')}}</div>
            <div class="mt-4 md:flex gap-4">
                <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary mb-4 md:mb-0" (click)="showModelDelete = false"
                    class="md:w-[200px]">{{t('modal.cancel')}}</std-button>
                <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="deleteSubElement()"
                    class="md:w-[200px]">{{t('modal.confirm')}}</std-button>
            </div>
        </div>
    </std-modal>
    <std-modal  cardClass="!max-w-[90vw] w-[90vw]" *ngIf="showModalSubElement" headerClass="bg-primary" [show]="showModalSubElement"
        [closeOnOutside]="false" (close)="showModalSubElement=false">
        <div class="text-tertiary text-large" header>{{t(isNewSubElement ? 'add' : 'modal.edit')}}</div>
        <div content class="custom-scroll grid gap-4">

            @for (dataForm of currentTab.table; track $index) {
            @if(isNewSubElement && dataForm.editable && dataForm.type !== 'select' && dataForm.type !== 'image'&& dataForm.type !== 'time'){<std-input customInputClass="custom-input" customLabel="label-input" [type]="dataForm.type"
                [(ngModel)]="subElementModalValue[dataForm.element]"
                [label]="t('labels.'+dataForm.element) + (dataForm.obligatory ? '*' : '')" labelPosition="top"
                [placeholder]="t('placeholders.'+dataForm.element)"></std-input>}
                @if(dataForm.creation && dataForm.type !== 'select' && dataForm.type === 'image'){
                    <input type="file" (change)="manageFiles($event,dataForm)" [placeholder]="t('placeholders.'+dataForm.element)">
                    }
            @if(!isNewSubElement && dataForm.creation && dataForm.type !== 'select' && dataForm.type !== 'image'&& dataForm.type !== 'time'){<std-input customInputClass="custom-input" customLabel="label-input" [type]="dataForm.type"
                [(ngModel)]="subElementModalValue[dataForm.element]"
                [label]="t('labels.'+dataForm.element) + (dataForm.obligatory ? '*' : '')" labelPosition="top"
                [placeholder]="t('placeholders.'+dataForm.element)"></std-input>}
            @if(isNewSubElement && dataForm.editable && dataForm.type === 'select' && dataForm.type !== 'image'&& dataForm.type !== 'time'){
                <std-select customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                [bindLabel]="dataForm.bindLabelSelect ?? 'label'"
                [bindValue]="dataForm.bindValueSelect ?? 'value'"
                [data]="dataForm.selectDataEndpoint ? listOfDataForSubSelects[dataForm.element] : dataForm.selectArray"
                customClassContaier="!border-primary custom-select"
                (onChangeValue)="manageChangeValueSubSelect(dataForm,$event)"
                [currentValue]="getCurrentValueForSubSelect(dataForm,subElementModalValue[dataForm.element])"
                [label]="t('labels.'+dataForm.element) + (dataForm.obligatory ? '*' : '')" labelPosition="top"
                [placeholder]="t('placeholders.'+dataForm.element)"></std-select>
            }
            @if(!isNewSubElement && dataForm.creation && dataForm.type === 'select' && dataForm.type !== 'image'&& dataForm.type !== 'time'){
                <std-select customLabel="label-input" customClassContainerElement="max-h-[250px] overflow-y-scroll custom-scrollbar"
                [bindLabel]="dataForm.bindLabelSelect ?? 'label'"
                [bindValue]="dataForm.bindValueSelect ?? 'value'"
                [data]="dataForm.selectDataEndpoint ? listOfDataForSubSelects[dataForm.element] : dataForm.selectArray"
                customClassContaier="!border-primary custom-select"
                (onChangeValue)="manageChangeValueSubSelect(dataForm,$event)"
                [currentValue]="getCurrentValueForSubSelect(dataForm,subElementModalValue[dataForm.element])"
                [label]="t('labels.'+dataForm.element) + (dataForm.obligatory ? '*' : '')" labelPosition="top"
                [placeholder]="t('placeholders.'+dataForm.element)"></std-select>
            }



            @if(((!isNewSubElement && dataForm.creation) || (isNewSubElement && dataForm.editable)) && dataForm.type ===
        'time'){
    <div (click)="specialModalTimeToShow =   'time-'+dataForm.element"> 
      
          @if (!isNewSubElement || subElementModalValue[dataForm.element]){<std-input
          customInputClass="custom-input"
          customLabel="label-input"
          class="pointer-events-none"
          [type]="'time'"
          [(ngModel)]="subElementModalValue[dataForm.element]"
          [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          "
          labelPosition="top"
          [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
          "
        ></std-input>}

     @if (isNewSubElement && !subElementModalValue[dataForm.element]){<std-input
          customInputClass="custom-input"
          customLabel="label-input"
          class="pointer-events-none"
          [type]="'time'"
          [value]="subElementModalValue[dataForm.element]"
          [label]="
            t(
              'labels.' + (dataForm.label ? dataForm.label : dataForm.element)
            ) + (dataForm.obligatory ? '*' : '')
          "
          labelPosition="top"
          [placeholder]="
            t(
              'placeholders.' +
                (dataForm.placeholder ? dataForm.placeholder : dataForm.element)
            )
          "
        ></std-input>}</div> 
        @if(specialModalTimeToShow === 'time-'+dataForm.element){
          <div class="flex h-screen  !w-screen bg-black !bg-opacity-35 place-content-center items-center fixed top-0 left-0 z-[9999]">
            <std-time-picker [showClock]="dataParams.showClock" [use24h]="dataParams.use24h" [startingTime]="!isNewSubElement ? subElementModalValue[dataForm.element] : '00:00'" (changeDate)="tempVariable = $event.formattedTime">
              <div footer class="mt-6 flex gap-4">
               <div class="w-full"> <std-button
                  buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                  (click)="specialModalTimeToShow = ''"
                  class="w-[200px]"
                  >{{ t("modal.cancel") }}</std-button
                ></div>
              <div class="w-full">  <std-button [ngClass]="{'opacity-35 pointer-events-none':isNewSubElement && !tempVariable }"
                  buttonClass="bg-primary focus:bg-primary hover:bg-primary"
                  (click)="subElementModalValue[dataForm.element] = tempVariable ? tempVariable : '00:00';tempVariable=null;specialModalTimeToShow = null"
                  class="w-[200px]"
                  >{{ t("modal.confirm") }}</std-button
                ></div>
              </div>
            </std-time-picker>
          </div>
        }
        }



            }



            <div class="mt-6 md:flex gap-4">
                <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary mb-4 md:mb-0"
                    (click)="showModalSubElement = false" class="md:w-[200px]">{{t('modal.cancel')}}</std-button>
                <std-button buttonClass="bg-primary focus:bg-primary hover:bg-primary" (click)="confirmSubElement()"
                    class="md:w-[200px]">{{t('modal.confirm')}}</std-button>
            </div>
        </div>
    </std-modal>
</div>